import {
  ADD_TAG,
  ADD_TAGS,
  DELETE_ALL_TAGS,
  DELETE_TAG,
  DISABLE_TAG,
  ENABLE_TAG,
  SELECT_TAG,
  SET_TAG_NUMBER,
  TagsAction,
  UNSELECT_TAG,
  UPDATE_TAGS,
} from "../types";
import { Tag, TagMap } from "../../types";

export const addTags = (tags: TagMap): TagsAction => {
  return {
    type: ADD_TAGS,
    payload: tags,
  };
};

export const updateTags = (tags: TagMap): TagsAction => {
  return {
    type: UPDATE_TAGS,
    payload: tags,
  };
};

export const addTag = (id: string, tag: Tag): TagsAction => {
  return {
    type: ADD_TAG,
    payload: {
      id: id,
      tag: tag,
    },
  };
};

export const selectTag = (id: string): TagsAction => {
  return {
    type: SELECT_TAG,
    payload: id,
  };
};

export const unselectTag = (id: string): TagsAction => {
  return {
    type: UNSELECT_TAG,
    payload: id,
  };
};

export const disableTag = (id: string): TagsAction => {
  return {
    type: DISABLE_TAG,
    payload: id,
  };
};

export const enableTag = (id: string): TagsAction => {
  return {
    type: ENABLE_TAG,
    payload: id,
  };
};

export const setTagNumber = (id: string, number: number): TagsAction => {
  return {
    type: SET_TAG_NUMBER,
    payload: {
      id: id,
      number: number,
    },
  };
};

export const deleteTag = (id: string): TagsAction => {
  return {
    type: DELETE_TAG,
    payload: id,
  };
};

export const deleteTags = (): TagsAction => {
  return {
    type: DELETE_ALL_TAGS,
  };
};
